import { Skeleton } from 'design-system';

import generateSkeletonKeys from '@/shared/lib/format/generateSkeletonKeys';

import { MarketWidgetSkeleton } from './MarketWidgetSkeleton';

const marketWidgetSkeletonKeys = generateSkeletonKeys(6);

const MarketsPageHeaderSkeleton = () => (
  <header
    className='flex min-w-0 items-center gap-1 py-6'
    data-testid='markets-page-header-skeleton'
  >
    <Skeleton className='mr-8 h-8 w-36 shrink-0' />
    <div className='flex min-w-0 flex-1 items-center gap-4 overflow-hidden'>
      <Skeleton className='h-8 w-24 shrink-0' />
      <Skeleton className='h-8 w-20 shrink-0' />
      <Skeleton className='h-8 w-28 shrink-0' />
    </div>
    <Skeleton className='ml-auto size-8 shrink-0 rounded-md' />
  </header>
);

export const MarketWidgetsSkeletonVisual = () => (
  <div
    className='apps__container grid w-full grid-cols-1 gap-6 [&>*]:min-w-0 [&>*]:overflow-hidden lg:grid-cols-2'
    data-testid='market-widgets-skeleton-grid'
  >
    {marketWidgetSkeletonKeys.map(key => (
      <MarketWidgetSkeleton key={key} />
    ))}
  </div>
);

export const MarketWidgetsSkeleton = () => (
  <section
    className='w-full'
    data-testid='market-widgets-skeleton'
  >
    <output
      aria-busy='true'
      aria-label='Loading dashboard widgets'
      className='sr-only'
    >
      Loading dashboard widgets
    </output>
    <div
      aria-hidden='true'
      data-testid='market-widgets-skeleton-visual'
    >
      <MarketWidgetsSkeletonVisual />
    </div>
  </section>
);

export const MarketsPageSkeleton = () => (
  <section
    className='w-full'
    data-testid='markets-page-skeleton'
  >
    <output
      aria-busy='true'
      aria-label='Loading market data'
      className='sr-only'
    >
      Loading market data
    </output>
    <div
      aria-hidden='true'
      data-testid='markets-page-skeleton-visual'
    >
      <MarketsPageHeaderSkeleton />
      <MarketWidgetsSkeletonVisual />
    </div>
  </section>
);

export { MarketWidgetSkeleton } from './MarketWidgetSkeleton';
